import { useQuery } from "@tanstack/react-query";
import { ClusterJobs } from "@graylog/server-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
export const SYSTEM_JOBS_QUERY_KEY = ["system", "jobs"];
const useSystemJobs = () => {
  const { data: jobs } = useQuery({
    queryKey: SYSTEM_JOBS_QUERY_KEY,
    queryFn: () => defaultOnError(
      ClusterJobs.list(),
      i18n.t("notifications.system_jobs_failed", { ns: "system" }),
      i18n.t("notifications.system_jobs_failed_title", { ns: "system" })
    ),
    refetchInterval: 2e3
  });
  return jobs;
};
export default useSystemJobs;
